<template>
  <div class="appointment_main">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          size="small"
          unlink-panels
          :picker-options="pickerOptions"
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <button-confirm-next value="登记审批" @confirm="showWindowLeftBox" style="margin-left: 10px;" />
        <input-select selectTitle="预约类型" :selectKey="'interviewMethod'" selectWidth="120px" :selectData="interviewMethodList" @search="search" style="margin-left: 10px;"/>
      </div>
      <input-search placeholder="预约人姓名/预约人手机" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @visitView="visitView" @lookOver="lookOver" :hasOperation="false" />

    <el-dialog title="来访人信息" :visible.sync="visitorVisible">
      <table-main :tableHead="visitorHead" :tableData="visitorList" :selection="false" :pagination="false" :hasOperation="false" @lookOver="lookOver" />
      <!--<el-table :data="visitorList">-->
        <!--<el-table-column property="visitorName" label="来访人姓名" width="50%" />-->
        <!--<el-table-column property="visitorPhone" label="来访人手机号" width="50%" />-->
      <!--</el-table>-->
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="lookOverImg" alt="" style="width: 60%;margin: 0 auto;">
    </el-dialog>

    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">

            <div class="search-line" style="margin: 10px 0">
              <div class="btn-box">

              </div>
              <input-search placeholder="姓名/手机号" @search="windowLeftSearch"/>
            </div>
            <div>
              <table-main :selection="false" :tableHead="windowLeftTableHead" :tableData="windowLeftTableData" :total="windowLeftTotal" :pageNum="windowLeftPageNum" :pageSize="windowLeftPageSize" :hasOperation="false" @changePagination="changeWindowLeftPagination" :row-click="windowLeftRowClick" />
            </div>
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>

    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      size="60%"
      :before-close="handleClose">
      <div class="person-management-drawer">
        <button @click="personDataToWindowLeft" class="el-icon-back"></button>
        <form>
          <img class="drawerPersonImg" :src="drawerPersonData.visitorPic" alt="" v-if="drawerPersonData.visitorPic">
          <p class="noDrawerPersonImg" v-else>暂无人员照片</p>
          <div class="form-line">
            <div class="line-text">
              <div>来</div>
              <div>访</div>
              <div>人</div>
              <div>姓</div>
              <div>名：</div>
            </div>
            <div>{{drawerPersonData.visitorName || '无'}}</div>
          </div>

          <div class="form-line">
            <div class="line-text">
              <div>来</div>
              <div>访</div>
              <div>人</div>
              <div>手</div>
              <div>机</div>
              <div>号：</div>
            </div>
            <div>{{drawerPersonData.visitorPhone || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>来</div>
              <div>访</div>
              <div>人</div>
              <div>单</div>
              <div>位：</div>
            </div>
            <div>{{drawerPersonData.visitorEnterprise || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>来</div>
              <div>访</div>
              <div>人</div>
              <div>身</div>
              <div>份</div>
              <div>证：</div>
            </div>
            <div>{{drawerPersonData.visitorIdCard || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>被</div>
              <div>访</div>
              <div>企</div>
              <div>业：</div>
            </div>
            <div>{{drawerPersonData.enterpriseName || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>被</div>
              <div>访</div>
              <div>人</div>
              <div>姓</div>
              <div>名：</div>
            </div>
            <div>{{drawerPersonData.bookingPersonName || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>来</div>
              <div>访</div>
              <div>事</div>
              <div>由：</div>
            </div>
            <div>{{drawerPersonData.bookingBusiness || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>来</div>
              <div>访</div>
              <div>时</div>
              <div>间：</div>
            </div>
            <div>{{drawerPersonData.visitStartTime || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>结</div>
              <div>束</div>
              <div>时</div>
              <div>间：</div>
            </div>
            <div>{{drawerPersonData.visitEndTime || '无'}}</div>
          </div>

          <div class="form-line">
            <div class="line-text">
              <div>备</div>
              <div>注：</div>
            </div>
            <div>{{drawerPersonData.memo || '无'}}</div>
          </div>
        </form>
        <div class="drawerBtnBox">
          <el-button size="small" class="btn-confirm"  @click="confirmApprove()">同意</el-button>
          <el-button size="small" class="reject-button"  @click="rejectApprove()" >驳回</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Visitor";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
import { nSuccess } from "../../../utils/notice";
import InputSelect from "../../../components/Input/InputSelect";

export default {
  components: {
    InputSelect,
    ButtonConfirmNext,
    TableMain,
    InputSearch,
    Breadcrumb
  },
  name: "appointment-record",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧访客",
          name: "appointment-record"
        },
        {
          value: "预约记录"
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      tableHead: [
        {
          prop: "bookingPersonName",
          label: "被访人姓名"
        },
        {
          prop: "bookingPersonPhone",
          label: "被访人手机号"
        },
        {
          prop: "enterpriseName",
          label: "被访人单位"
        },
        {
          prop: "bookingBusiness",
          label: "预约事由"
        },
        {
          prop: "interviewMethod",
          label: "预约类型"
        },
        {
          prop: "visitorName",
          label: "来访人姓名"
        },
        {
          prop: "visitorPhone",
          label: "来访人手机号"
        },
        {
          prop: "visitorCarNumber",
          label: "来访人车牌号"
        },
        {
          prop: "visitorEnterprise",
          label: "来访人单位"
        },
        {
          prop: "picUrl",
          label: "来访人照片",
          isLookOver: true
        },
        {
          prop: "visitorTime",
          label: "来访时间"
        }
      ],
      tableData: [],
      operationArr: ["visitView"],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      timeValue: [],
      requestData: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        searchKey: "",
        interviewMethod: ""
      },
      interviewMethodList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "访客主扫",
          label: "访客主扫"
        },
        {
          key: "被访邀请",
          label: "被访邀请"
        }
      ],
      visitorVisible: false,
      visitorHead: [
        {
          prop: "visitorName",
          label: "来访人姓名"
        },
        {
          prop: "visitorPhone",
          label: "来访人手机号"
        },
        {
          prop: "picUrl",
          label: "人员照片",
          isLookOver: true
        }
      ],
      visitorList: [],
      lookOverImg: "",
      dialogVisible: false,

      windowLeftBox: false,
      windowLeftTableHead: [
        {
          prop: "visitorName",
          label: "来访人姓名"
        },
        {
          prop: "visitorPhone",
          label: "来访人手机号"
        },
        {
          prop: "visitorEnterprise",
          label: "来访人单位"
        },
        {
          prop: "bookingBusiness",
          label: "来访事由"
        },
        {
          prop: "yqPicUrl",
          label: "人员照片",
          isPic: true
        },
        {
          prop: "createTime",
          label: "登记时间"
        }
      ],
      windowLeftTableData: [],
      windowLeftSearchKey: "",
      windowLeftTotal: 0,
      windowLeftPageNum: 1,
      windowLeftPageSize: 10,
      drawer: false,
      drawerPersonData: {}
    };
  },
  created() {
    this.getCreatTime();
    // this.getPage()
  },
  activated() {
    this.getPage();
  },
  methods: {
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + "-" + month + "-" + date;
      this.timeValue[1] = year + "-" + month + "-" + date;
      this.getPage();
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timeValue) {
        reqData.startTime = `${this.timeValue[0]} 00:00:00`;
        reqData.endTime = `${this.timeValue[1]} 23:59:59`;
      } else {
        reqData.startTime = '';
        reqData.endTime = '';
      }
      this.$axios
        .post(api.getVisitorsPage, reqData)
        .then(res => {
          let list = res.data.data.list;
          this.total = res.data.data.total;
          list.map(v => {
            v.picUrl = v.visitorPic;
            if (v.visitStartTime && v.visitEndTime) {
              v.visitorTime = `${v.visitStartTime}至${v.visitEndTime}`;
            } else {
              v.visitorTime = "";
            }
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取预约记录失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    visitView(code) {
      this.$axios
        .post(api.getInvitedPersonListByBookingCode, {
          code
        })
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            v.picUrl = v.visitorPic;
          });
          this.visitorList = data;
          this.visitorVisible = true;
        })
        .catch(errorHandler("获取预约记录失败"));
    },
    lookOver(imgUrl) {
      this.lookOverImg = imgUrl;
      this.dialogVisible = true;
    },

    changeWindowLeftPagination(data) {
      this.windowLeftPageNum = data[0];
      this.windowLeftPageSize = data[1];
      this.getVisitorRegisterPage();
    },

    // 展示人员申请
    showWindowLeftBox() {
      this.windowLeftBox = true;
      this.getVisitorRegisterPage();
    },

    // 返回
    personDataToWindowLeft() {
      this.drawer = false;
      this.windowLeftBox = true;
    },

    // 点击人员查看详情
    windowLeftRowClick(row, event, column) {
      this.windowLeftBox = false;
      this.drawer = true;
      this.drawerPersonData = row;
      // this.getPersonBaklogByCode(row.baklogCode)
    },

    windowLeftSearch(v) {
      this.windowLeftPageNum = 1;
      this.windowLeftSearchKey = v;
      this.getVisitorRegisterPage();
    },

    handleClose(done) {
      done();
      this.windowLeftBox = true;
    },

    // 查询人员申请列表
    getVisitorRegisterPage() {
      this.$axios
        .post(api.getVisitorRegisterPage, {
          appointmentStatus: "0",
          pageNum: this.windowLeftPageNum,
          pageSize: this.windowLeftPageSize,
          searchKey: this.windowLeftSearchKey
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.yqPicUrl = v.visitorPic;
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19);
              }
            });
            this.windowLeftTotal = res.data.data.total;
            this.windowLeftTableData = data;
          }
        })
        .catch(errorHandler("获取申请列表失败"));
    },

    // 同意申请
    confirmApprove() {
      this.$axios
        .post(`${api.passTheVisitor}`, this.drawerPersonData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("操作成功");
            this.drawer = false;
            this.windowLeftBox = true;
            this.getVisitorRegisterPage();
          }
        })
        .catch(errorHandler("操作失败"));
    },

    // 驳回申请
    rejectApprove() {
      let drawerPersonData = this.drawerPersonData;
      drawerPersonData.unApproveReason = this.unApproveReason;
      this.$axios
        .post(`${api.notPassTheVisitor}`, drawerPersonData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("操作成功");
            this.drawer = false;
            this.windowLeftBox = true;
            this.approveDialog = false;
            this.getVisitorRegisterPage();
          }
        })
        .catch(errorHandler("操作失败"));
    }
  },
  watch: {
    visitorVisible() {
      if (!this.visitorVisible) {
        this.visitorList = [];
      }
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.appointment_main {
  .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
    /*width: 50%!important;*/
  }

  .right-slide-enter,
  .right-slide-leave-active {
    transform: translateX(100%);
  }

  .right-slide-leave-active,
  .right-slide-enter-active {
    transition: all 0.3s;
  }
  .window-left-box {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 60%;
    z-index: 10;
  }
  .window-left-box .move-enter-active,
  .window-left-box .move-leave-active {
    transition: all 2s linear;
    transform: translate3d(0, 0, 0);
  }
  .window-left-box .move-enter,
  .window-left-box .move-leave {
    transform: translate3d(100%, 0, 0);
  }
  .window-left-main {
    width: 100%;
    height: 100%;
    z-index: 30;
    background: #ffffff;
    padding: 5px 10px;
    overflow: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0.4;
    z-index: -1;
    background-color: #000000;
    transition: opacity 0.5s ease;
  }

  form {
    width: 450px;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 25px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text {
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 100px;
    display: flex;
    justify-content: space-between;
  }
  .line-info {
    width: 220px;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }

  .person-management-drawer {
    .el-icon-back {
      margin: 20px 20px 10px;
      display: block;
      border: 0;
      font-size: 20px;
      background-color: #ffffff;
      cursor: pointer;
    }
    .el-icon-back:hover {
      color: #00a0e6;
    }
    .all-table-class .el-table td {
      padding: 10px 0;
    }
    form {
      position: relative;
      .drawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
      }
      .noDrawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
        height: 150px;
        line-height: 160px;
        border: 1px dashed #dcdfe6;
        text-align: center;
        color: #999999;
      }
    }
  }
  .drawerBtnBox {
    width: 360px;
    padding-right: 60px;
    margin: 0 auto;
    .btn-confirm {
      border: 0;
      color: #fff;
      padding: 8px 16px;
      background-color: #00a0e6;
      border-radius: 4px;
      margin-right: 60px;
    }
    .btn-confirm:hover {
      color: #fff;
      background-color: #06b3ff;
    }
    .reject-button {
      border: 0;
      background-color: #f25721;
      color: #ffffff;
      border-radius: 4px;
    }
    .reject-button:hover {
      background-color: #f96e3d;
    }
  }
}

.el-dialog__body {
  .el-table .cell {
    text-align: center;
  }
  .el-table th > .cell {
    color: #48576a;
    font-weight: bold;
  }
}
.el-dialog {
  .el-dialog .el-dialog__body .el-table__empty-block {
    margin: 0 auto;
  }
  .el-table__empty-text {
    width: auto;
  }
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__body {
    .el-table th:first-child {
      width: auto !important;
    }
  }
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/AppointmentRecord/AppointmentRecord.vue